import Play from 'assets/icons/Play';
import PropTypes from 'prop-types';
import React from 'react';
import { media } from 'utils/mediaqueries';
import styled from 'libs/styled';
import transitions from 'config/theme/transitions';

const Wrapper = styled('div', { shouldForwardProp: prop => ['color', 'hoverPlayButtonColor'].indexOf(prop) === -1 })`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    transition: all ${transitions.primary};

    #play-button-icon {
        path,
        rect {
            transition: all ${transitions.primary};
        }
        path {
            fill: ${({ color }) => color};
        }
        rect {
            stroke: ${({ color }) => color};
        }
    }

    ${media.hover} {
        &:hover {
            #play-button-icon {
                path {
                    fill: ${({ hoverPlayButtonColor }) => hoverPlayButtonColor};
                }
                rect {
                    fill: ${({ color }) => color};
                }
            }
        }
    }
`;

const VideoPlayButton = ({ children, hoverPlayButtonColor = '', ...rest }) => (
    <Wrapper hoverPlayButtonColor={hoverPlayButtonColor} {...rest}>
        <Play id="play-button-icon" color="currentColor" marginBottom="16px" />
        {children}
    </Wrapper>
);

VideoPlayButton.propTypes = {
    children: PropTypes.node.isRequired,
    hoverPlayButtonColor: PropTypes.string,
};

export default VideoPlayButton;
